<template>
  <DetailCard title="Contato">
    <div class="flex flex-col gap-5">
      <div class="flex items-start gap-3">
        <v-icon size="20" color="grey-darken-1" class="mt-0.5">{{ mdiEmailOutline }}</v-icon>
        <div class="min-w-0">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">E-mail</p>
          <p data-testid="doctor-contact-email" class="text-base text-gray-900 break-words">
            {{ email }}
          </p>
        </div>
      </div>

      <div class="flex items-start gap-3">
        <v-icon size="20" color="grey-darken-1" class="mt-0.5">{{ mdiPhoneOutline }}</v-icon>
        <div>
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Telefone</p>
          <p data-testid="doctor-contact-phone" class="text-base text-gray-900">{{ phone }}</p>
        </div>
      </div>

      <div v-if="location" class="flex items-start gap-3">
        <v-icon size="20" color="grey-darken-1" class="mt-0.5">{{ mdiMapMarkerOutline }}</v-icon>
        <div>
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Localização</p>
          <p data-testid="doctor-contact-location" class="text-base text-gray-900">
            {{ location }}
          </p>
        </div>
      </div>
    </div>
  </DetailCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiEmailOutline, mdiPhoneOutline, mdiMapMarkerOutline } from '@mdi/js'

import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import DetailCard from '../atoms/DetailCard.vue'
import { formatPhone } from '@/utils/formatters'

const props = defineProps<{
  doctor: DoctorDetailResponse
}>()

const email = computed(() => props.doctor.doctor.user?.email || 'Não informado')
const phone = computed(() => {
  const raw = props.doctor.doctor.user?.mainPhone?.phoneNumber
  return raw ? formatPhone(raw) : 'Não informado'
})
const city = computed(() => props.doctor.doctor.user?.mainAddress?.city)
const uf = computed(() => props.doctor.doctor.user?.mainAddress?.state)

const location = computed(() => {
  if (city.value && uf.value) return `${city.value} - ${uf.value}`
  return city.value || uf.value || ''
})
</script>
